module.exports = __webpack_public_path__ + "static/img/colegio o persona.f4f026db.png";